/**
 * base64.ts — byte/base64 conversion for OOXML package payloads.
 *
 * Extracted from pptxSubdeck.ts so every feature that hands a `.pptx` package
 * to `insertSlidesFromBase64` encodes it the same way.
 */

/**
 * Chunk size for the code-point walk below. Kept well under the engine's
 * argument-count limit for spread calls, which `String.fromCodePoint(...)`
 * would otherwise blow past on a multi-megabyte deck.
 */
const CODE_POINT_CHUNK = 0x8000;

/** Encode raw bytes as a base64 string. */
export function uint8ToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += CODE_POINT_CHUNK) {
    // Bytes are 0–255, so each is a single-unit code point — fromCodePoint
    // yields the same binary string btoa expects.
    binary += String.fromCodePoint(...bytes.subarray(i, i + CODE_POINT_CHUNK));
  }
  return btoa(binary);
}
